module.exports = __webpack_public_path__ + "static/media/phone.c3fba0a5.gif";